import type { ICellRendererParams } from 'ag-grid-community'
import React from 'react'
import type { AttendancePlayer } from '../../types'
import { isWaiverLocked } from '@sportninja/common/features/game/attendance/utils/waiverLock'
import AttendanceAvailIcons from '../AttendanceAvailIcons'
import { useAttendanceSection } from './AttendanceSectionContext'

/** AVAILABLE column: the Yes / Maybe / No icons (roster rows). */
const AvailabilityCell = ({ data }: ICellRendererParams<AttendancePlayer>) => {
  const {
    waiverEnforced,
    isSpareCandidate,
    availYesNoOnly,
    onPressAttendanceStatus,
  } = useAttendanceSection()

  if (!data) {
    return null
  }

  return (
    <AttendanceAvailIcons
      attendanceStatus={data.attendance_status}
      disabled={
        isWaiverLocked(data, waiverEnforced, isSpareCandidate) ||
        data.is_suspended
      }
      yesNoOnly={availYesNoOnly}
      onPress={(next) => {
        const result = onPressAttendanceStatus(data.id, next)
        if (result && typeof result.catch === 'function') {
          result.catch(() => {})
        }
      }}
    />
  )
}

export default AvailabilityCell
